import { Accordion, Col, Row } from "react-bootstrap";
import type { AccountHoldingResponse } from "../../../api/src/accounts/accounts.service";
import type { RebalanceType } from "../../../api/src/rebalances/rebalances.service";
import RebalanceAccountInsights, {
  type RebalanceAccountWithMetrics,
} from "./RebalanceAccountInsights";
import TradesEditor from "./TradesEditor";

export type { RebalanceAccountWithMetrics } from "./RebalanceAccountInsights";

const RebalanceAccountInfo = ({
  rebalanceAccount,
  accountIndex,
  holdings,
  rebalanceType,
  householdModelId,
  editable = false,
}: {
  rebalanceAccount: RebalanceAccountWithMetrics;
  accountIndex: number;
  holdings: AccountHoldingResponse[];
  rebalanceType: RebalanceType;
  householdModelId?: number;
  editable: boolean;
}) => {
  return (
    <>
      <RebalanceAccountInsights
        rebalanceAccount={rebalanceAccount}
        rebalanceType={rebalanceType}
        householdModelId={householdModelId}
      />
      <Row className="mt-4">
        <Col className="mb-4">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Trades</Accordion.Header>
              <Accordion.Body>
                <TradesEditor
                  accountIndex={accountIndex}
                  holdings={holdings}
                  disabled={!editable}
                />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </>
  );
};

export default RebalanceAccountInfo;
